import React from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '../store/user';

const UserDebugInfo = () => {
  const user = useSelector(selectUser);

  // 只在开发环境显示
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: 'rgba(0, 0, 0, 0.8)',
      color: 'white',
      padding: '10px',
      borderRadius: '5px',
      fontSize: '12px',
      maxWidth: '300px',
      zIndex: 9999
    }}>
      <h4 style={{ margin: '0 0 10px 0', fontSize: '14px' }}>用户调试信息</h4>
      <div><strong>UUID:</strong> {user.uuid}</div>
      <div><strong>已播放视频:</strong> {Object.keys(user.playedVideos).length}</div>
      <div><strong>已点赞文章:</strong> {Object.keys(user.likedArticles).length}</div>
      <div><strong>加载状态:</strong> 
        播放: {user.loading.trackPlay ? '是' : '否'}, 
        点赞: {user.loading.like ? '是' : '否'}
      </div>
      {user.error && (
        <div style={{ color: '#ff6b6b' }}>
          <strong>错误:</strong> {user.error}
        </div>
      )}
      
      <details style={{ marginTop: '10px' }}>
        <summary style={{ cursor: 'pointer' }}>详细信息</summary>
        <pre style={{ 
          fontSize: '10px', 
          overflow: 'auto', 
          maxHeight: '200px',
          marginTop: '5px'
        }}>
          {JSON.stringify(user, null, 2)}
        </pre>
      </details>
    </div>
  );
};

export default UserDebugInfo; 